import * as React from 'react';
import { useEffect, useState } from 'react';
import { Select, Tooltip, Layout } from '@iba-team/portal-react-components/dist';
import { SelectableDivisionsListItem } from '../../types';
import { usePartialState } from '../calendar/CalendarPage';
import './ReportsSector.scss';
import { Table } from 'antd';
import { ReactComponent as InfoIcon } from '@iba-team/portal-react-components/dist/svg/outline/information.svg';
import { ReportSectorStore } from '../../store/ReportSector';
import { getYear } from 'date-fns';
import { observer } from 'mobx-react';
import { buildDownloadFile, insertOneByIndex } from '../../utils/functions';
import { BackArrow } from './BackArrow';
import { useAnalytics } from '../../utils/hooks';
import { PROFILE_ROUTE } from '../../utils/consts';
import { Link } from 'react-router-dom';
import ExportButton from '../../utils_components/ExportButton';
export interface SectorReportQueryI{
  year: Date,
  division: SelectableDivisionsListItem,
  page: number,
  perPage: number,
  sorting: [
    {
      name: '',
      order: ''
    }
  ] | [
    {
      name: 'total',
      order: 'ASC'
    }
  ] | [
    {
      name: 'total',
      order: 'DESC'
    }
  ] | [
    {
      name: 'available',
      order: 'ASC',
    }
  ] | [
    {
      name: 'available',
      order: 'DESC'
    }
  ]
}

export const ReportSector = observer(() => {
  const currentDate = new Date();
  const {headers,memberData,memberColumns,memberElement,fetchHeaders,fetchData, isReportDownloading, downloadReport} = ReportSectorStore;

  const [params,setParams] = useState<SectorReportQueryI>({
    division: { hierarchyId: 0, hierarchyName: '', hierarchyPath: '' },
    page: 1,
    year: currentDate,
    perPage: 10,
    sorting: [{ name: '', order: '' }]
  });

  useEffect(()=>{
    fetchData(getYear(params.year));
  },[params.year]);

  useEffect(()=>{
    fetchHeaders();
  },[]);

  const columnsToTable = insertOneByIndex(headers)(2)( {
    key: 3,
    value: '',
    tooltip: null,
    sortable:false
  }
  ).map((item,index)=>{
    const updateIndex = index<3? item.key: index+1;
    if(item.sortable){
      return  {
        key: updateIndex,
        title: <div className={'sector_table__column'}>
          <span>{item.value}</span>
          <Tooltip title={item.tooltip}>{item.tooltip && <InfoIcon />}</Tooltip>
        </div>,
        dataIndex: updateIndex,
        showSorterTooltip: false,
        sortDirections: ['ascend', 'descend'],
        sorter:(a: any, b: any) => {
          const prepareA = a[updateIndex].toString();
          const prepareB = b[updateIndex].toString();
          if(prepareA.indexOf('/') !== -1){
            return +prepareA.split('/')[0] - +prepareB.split('/')[0];
          }
          if(!isNaN(+a[updateIndex])){
            return +a[updateIndex] - +b[updateIndex];
          }
          if (updateIndex === 2) {
            // sort by latinName
            return a[2].props.children > b[2].props.children ? 1 : -1;
          }
          return a[updateIndex] > b[updateIndex];
        },
      };
    }

    return {
      key: updateIndex,
      title: <div className={'sector_table__column'}>
        <span>{item.value}</span>
        <Tooltip title={item.tooltip}>{item.tooltip && <InfoIcon />}</Tooltip>
      </div>,
      dataIndex: updateIndex,
      showSorterTooltip: false,
      sortDirections: ['ascend', 'descend'],
      sorter: false
    };
  });

  const handleUserState = (username: {name: string, id: number}, filter: {profileLinkVisible: boolean, userActive: boolean}) => {
    if(filter.profileLinkVisible && !filter.userActive){
      return  <Link className={'activeUserBlock'} to={`${PROFILE_ROUTE}/${username.id}`}>{username.name} [Inactive]</Link>;
    }
    if(!filter.profileLinkVisible && !filter.userActive){
      return <div className={'inactiveUserBlock'}>{username.name} [Incative]</div>;
    }
    if(filter.profileLinkVisible && filter.userActive){
      return  <Link className={'activeUserBlock'} to={`${PROFILE_ROUTE}/${username.id}`}>{username.name}</Link>;
    }
  };

  const tableDataToTable = memberColumns.map(item=>{
    const splitDoubleValue = item[4].toString().split('/');
    const findUser = memberElement.find(i => i.id === item[0]);
    // eslint-disable-next-line @typescript-eslint/no-unused-expressions,@typescript-eslint/ban-ts-comment
    // @ts-ignore
    // eslint-disable-next-line @typescript-eslint/no-unused-expressions
    item[2] =   handleUserState({name: `${findUser.latinSurname} ${findUser.latinName}`, id: item[0]}, {profileLinkVisible: findUser.profileLinkVisible, userActive: findUser.userActive});
    item[4] = `${splitDoubleValue[0]}/${splitDoubleValue[1]}`;
    return item;
  });
  const division: SelectableDivisionsListItem[] = [memberData.headDivision];
  const partialParams = (changes: Partial<SectorReportQueryI>) => setParams(usePartialState(changes));


  const buildFile = () => {
    downloadReport(memberData.headDivision).then((response) => {
      return response?.blob();
    }).then((blob) => buildDownloadFile(blob, ''));
  };

  const renderHeader = () => {
    return {
      layoutName: <BackArrow text={'sectorReportsBackText'} reportType={'Sector'}/>,
      right: <div style={{gridColumnGap: '12px', display: 'flex'}}>
        <Select value={division[0].hierarchyName}
          disabled
          onChangeValue={value => partialParams({division: value})} render={item=> item.hierarchyName}
          list={division}
          uniqueElement={el => el.hierarchyId === division[0].hierarchyId}
        />
        <ExportButton isDownloading={isReportDownloading} onClick={buildFile} />
      </div>
    };
  };

  return(
    <Layout  className={'sector_page'} header={renderHeader()}>
      <Table
        /* eslint-disable-next-line @typescript-eslint/ban-ts-comment */
        /*// @ts-ignore*/
        columns={columnsToTable}
        dataSource={tableDataToTable}
        pagination={false}
        className={'sector_table'}
        onRow={(record,index) => {
          if(record && Number.isInteger(index)){
            record[1] = index ? index + 1 : 1;
          }
          return {
            onClick: () => {
              if(index !== undefined){
                useAnalytics('Reports', 'from_reports_to_profile', 'sector_report');
              }
            }
          };
        }} />
    </Layout>
  );
});
